import { BLOG_DRAFT_STATUS } from 'src/data/project';

export const getBlogProjectEditingDrafts = (project) =>
  filterEditingDrafts(project?.blogPostBuilderDrafts || []);

export const filterEditingDrafts = (drafts) =>
  drafts
    .filter((draft) => draft.status === BLOG_DRAFT_STATUS.editing)
    .sort((a, b) => a.draftId - b.draftId);
